"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationDoseDto = instanceOfVaccinationDoseDto;
exports.VaccinationDoseDtoFromJSON = VaccinationDoseDtoFromJSON;
exports.VaccinationDoseDtoFromJSONTyped = VaccinationDoseDtoFromJSONTyped;
exports.VaccinationDoseDtoToJSON = VaccinationDoseDtoToJSON;
exports.VaccinationDoseDtoToJSONTyped = VaccinationDoseDtoToJSONTyped;
const VaccinationManufacturer_1 = require("./VaccinationManufacturer");
/**
 * Check if a given object implements the VaccinationDoseDto interface.
 */
function instanceOfVaccinationDoseDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    return true;
}
function VaccinationDoseDtoFromJSON(json) {
    return VaccinationDoseDtoFromJSONTyped(json, false);
}
function VaccinationDoseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'manufacturer': json['manufacturer'] == null ? undefined : (0, VaccinationManufacturer_1.VaccinationManufacturerFromJSON)(json['manufacturer']),
        'date': (new Date(json['date'])),
    };
}
function VaccinationDoseDtoToJSON(json) {
    return VaccinationDoseDtoToJSONTyped(json, false);
}
function VaccinationDoseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'manufacturer': (0, VaccinationManufacturer_1.VaccinationManufacturerToJSON)(value['manufacturer']),
        'date': ((value['date']).toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=VaccinationDoseDto.js.map